import { httpRequest } from "../../http";

export class CommandAddBrandAsset {
    async run(organizationId: string, brandId: string, file: File, tag?: string, makeDefault = false) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/organizations/${organizationId}/brands/${brandId}/assets/`;
        const form = new FormData();
        form.append("file", file);
        if (tag) form.append("tag", tag);
        form.append("make_default", String(makeDefault));
        return await httpRequest<any>(url, { method: "POST", body: form });
    }
}
